import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseSiteService, ClientTokenService, UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { B2bunitService } from 'src/app/service/b2bunit/b2bunit.service';
import { ComponentService } from 'src/app/service/component.service';

@Component({
  selector: 'app-unit-selection-list',
  templateUrl: './unit-selection-list.component.html',
  styleUrls: ['./unit-selection-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UnitSelectionListComponent implements OnInit, OnDestroy {
  B2BunitLists$: Observable<any>;
  body = document.querySelector('body');
  header = document.querySelector('header');
  globalMsg = document.querySelector('cx-global-message');
  constructor(
    private cd: ChangeDetectorRef,
    private componentService: ComponentService,
    protected clientToken: ClientTokenService,
    private b2bunitService: B2bunitService,
    protected auth: UserIdService,
    protected baseService: BaseSiteService
  ) {
    this.header.style.display = 'block';
    this.globalMsg.setAttribute('style', 'display:block;');
    this.loadData();
  }

  loadData() {
    this.B2BunitLists$ = this.b2bunitService.getCurrentUserB2BUnits().pipe(
      filter(Boolean),
      map((result: any) => {
        this.cd.detectChanges();
        return result;
      })
    );
  }

  ngOnInit() {
    this.body.classList.add('unit-selection-page');

    if (!this.componentService.isPageLoadedFromLogin$.getValue()) {
      this.componentService.isPageLoadedFromLogin$.next(true);
    }
  }

  ngOnDestroy() {
    this.body.classList.remove('unit-selection-page');
  }
}
